<template>
  <div>
    <van-popup style="border-radius: 10px;" get-container="body" v-model="remarkVisble" :close-on-click-overlay="false">
      <div class="printModle">
        <h2 class="info">备注
          <span class="cler" @click="setDefalult">清除备注</span>
        </h2>
        <div class="d1">
          <div :class="['index-popup-branch', isNormalorderPage ? 'general-remarks' : '']">
            <!--我的自主订单列表和详情待收货和待揽件才显示常规备注 -->
            <div class="btn general">
              <button :class="[activeForm.four.active ? 'active4' : 'un4']" @click="changeHadler('four')">
                常规备注
              </button>
            </div>
            <div class="btn">
              <button :class="[activeForm.one.active ? 'active1' : 'un1']" @click="changeHadler('one')">
                无货
              </button>
            </div>
            <div class="btn">
              <button :class="[activeForm.two.active ? 'active2' : 'un2']" @click="changeHadler('two')">
                部分有货
              </button>
            </div>
            <div class="btn"> 
              <button :class="[activeForm.three.active ? 'active3' : 'un3']" @click="changeHadler('three')">
                待调货
              </button>
            </div>
          </div>
          <van-field
            class="textt"
            v-model="form.message"
            rows="2"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="可填写100汉字"
            show-word-limit
          />
        </div>
      </div>
      <div class="printFooter">
        <div class="d0">
          <div class="d1" @click="remarkVisble = false">取消</div>
          <div class="d2">
            <van-button @click="doSubmit" :loading="loading">确定</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
export default {
  name: '',
  props: {
  },
  data() {
    return {
      remarkVisble: false,
      form:{
       message:''
      },
      activeForm:{
        one:{
          active:false
        },
        two:{
          active:false
        },
        three:{
          active:false
        },
        four: {
          active: false
        }
      },
      loading:false,
      subOrderId:'',
      isNormalorderPage: ''
    }
  },
  methods: {
    init(row, from){
      this.subOrderId = row.id
      if(row.branchRemarkType){
        row.branchRemarkType == 1 && (this.activeForm.one.active = true)
        row.branchRemarkType == 2 && (this.activeForm.two.active = true)
        row.branchRemarkType == 3 && (this.activeForm.three.active = true)
        row.branchRemarkType == 4 && (this.activeForm.four.active = true)
      }
      this.form.message = row.branchRemark || ''
      this.remarkVisble = !this.remarkVisble

      /**
       * 如果是员工端我的自主订单调用
       * 在以下三个文件
       * @views/beeorder/components/normalItem.vue
       * @views/me/components/detailNormal.vue
       * @views/me/components/detailQuick.vue
       * 会调init方法 传入from 值为 'normalorder'
       */
      this.isNormalorderPage = from === 'normalorder'
    },
    changeHadler(name){
      if(this.activeForm[name].active){
        this.activeForm[name].active = false
        return
      }
      for (const key in this.activeForm) {
        const element = this.activeForm[key];
        element.active = false
      }
      this.activeForm[name].active = !this.activeForm[name].active
    },
    doSubmit(){
      this.loading = true
      let str=this.form.message.trim(); 
      let branchRemarkType = this.activeForm.one.active ? '1' : this.activeForm.two.active ? '2' : this.activeForm.three.active ? '3' : this.activeForm.four.active ? '4' : ''
      http({
        url: 'order/app/bees/branchRemark',
        method: "POST",
        parmes:{
          "branchRemark": str,
          "branchRemarkType": branchRemarkType,
          "subOrderId": this.subOrderId
        }
      }).then(rps => {
        if (rps.code === 200 && rps.data) {
          this.$toast(rps.message || '备注成功');
          this.loading = false;
          this.setDefalult()
          this.$emit('callbackFun');
          this.remarkVisble = false;
        }
      }).catch(rps=>{
        this.remarkVisble = false;
        this.loading = false
      });
    },
    setDefalult(){
      for (const key in this.activeForm) {
        const element = this.activeForm[key];
        element.active = false
      }
      this.form.message = ''
    }
  },
  created() {
  },
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
.printModle{
  width: 560px;
  background:#ffffff;
  border-top-left-radius:10px;
  border-top-right-radius:10px;
  padding-top: 30px;
  padding-left: 39px;
  padding-right: 36px;
  .info{
    font-size: 28px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 30px;
    clear: both;
    .cler{
      float: right;
      font-size: 20px;
      color: #999;
      font-weight: normal;
    }
  }
  .d1{
    .index-popup-branch {
      font-size: 0;
    }
    .index-popup-branch .btn {
      display: inline-block;
      box-sizing: border-box;
      width: 155px;
      margin-right: 10px;
      margin-bottom: 20px;
      background-color: #ffffff;
    }
    .index-popup-branch button{
      display: inline-block;
      background-color: #ffffff;
      width: 100%;
      height: 60px;
      border-radius: 10px;
      border: 2px solid #cccccc;
      box-sizing: border-box;
      font-size: 24px;
      text-align: center;  
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 20px;
      color: #333333;
      position: relative;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
        width: 38px;
        height: 38px;
        display: none;
        line-height: 0;
      }
    }
    .index-popup-branch .general {
      display: none;
    }
    .index-popup-branch .active1 {
      background-color: #FFE7E6;
      border:1PX solid #FFE7E6;
      color: #ED3939;
    }
    .index-popup-branch .active3 {
      background-color: #F0F7FF;
      border:1PX solid #F0F7FF;
      color: #409EFF;
    }
    .index-popup-branch .active2 {
      background-color: #FFF8F1;
      border:1PX solid #FFF8F1;
      color: #F8A651;
    }
    .index-popup-branch .active4 {
      background: #def2e1;
      border:1PX solid #def2e1;
      color: #07c160;
    }
    .index-popup-branch .un1 {
      background-color: #ffffff;
      border:1PX solid #FFE7E6;
      color: #ED3939;
    }
    .index-popup-branch .un3 {
      background-color: #ffffff;
      border:1PX solid #F0F7FF;
      color: #409EFF;
    }
    .index-popup-branch .un2 {
      background-color: #ffffff;
      border:1PX solid #FFF8F1;
      color: #F8A651;
    }
    .index-popup-branch .un4 {
      border:1PX solid #def2e1;
      color: #07c160;
    }
    .textt{
      width: 550px;
      background: #FFFFFF;
      border: 1PX solid #CCCCCC;
      /deep/textarea {
        min-height: 150px;
      }
    }
    .general-remarks {
      .btn {
        display: inline-block;
        width: 130px;
      }
      button {
        padding: 0 4px;
      }
    }
  }
}
.printFooter{
  width:100%;
  background:#ffffff;
  border-top: 1PX solid #D8D8D8;
  margin-top: 20px;
  font-size: 28px;
  .d0{
    text-align: center;
    height: 100px;
    line-height: 100px;
    clear: both;
    width: 100%;
    display:-webkit-flex;
    display:flex;
    -webkit-justify-content:flex-start;
  	justify-content:flex-start;
    .d1{
      color: #333333;
      border-right: 1PX solid #D8D8D8;
      width: 50%;
      border-bottom-left-radius:10px;
    }
    .d2{
      color: #F8A651;
      width: 50%;
      border-bottom-right-radius:10px;
      /deep/.van-button--default {
        border: 0;
        width: 100%;
        height: 100%;
        color: #F8A651;
      }
    }
  }
}
</style>